import algos from '../api/algos';
import bing from '../api/bing';


export const getSolution_biseccion = (formValues) => {

    return async function (dispatch) {
        const response = await algos.get('/biseccion', {
            params: {
                funcion: formValues.funcion,
                rango_a: formValues.rango_a,
                rango_b: formValues.rango_b,
                error: formValues.error
            }
        });

        dispatch({ type: 'SOLUTION_BISECCION', payload: response.data });
    };
};


export const getSolution_newton = (formValues) => {

    return async function (dispatch) {
        const response = await algos.get('/newton', {
            params: {
                funcion: formValues.funcion,
                punto: formValues.punto,
                iteraciones: formValues.iteraciones
            }
        });

        dispatch({ type: 'SOLUTION_NEWTON', payload: response.data });
    };
};

export const getMatrix = (formValues) => {

    return async function (dispatch) {
        const response = await bing.get('/DistanceMatrix' +
            '?origins=' + formValues.coordenadas +
            '&destinations=' + formValues.coordenadas +
            '&travelMode=driving' +
            '&key=' + process.env.REACT_APP_BING_KEY);


        dispatch({ type: 'MATRIX', payload: response.data.resourceSets });
    };

};

export const getRoute = (Matrix) => {

    const distancias = JSON.stringify(Matrix.results)
    const num_nodes = Matrix.destinations.length
    return async function (dispatch) {
        const response = await algos.post('/vrp', {
            matrix: distancias,
            num_nodes: num_nodes
        });

        dispatch({ type: 'VRP_SOLUTION', payload: response.data });
    };

};